import { getAsync } from '../../shared/api.service'
import { useApiBlob } from '../api-blob'
import { useApiForm } from '../api-form'
import { useApiList } from '../api-list'
import { urlArgs } from '../state'

export const useApiListChunkReportCustomOrg = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-custom-org${urlArgs(args)}`)
export const useApiListReportCustomOrg = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-custom-org${urlArgs(args)}`)

export const useApiListAnalytic = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic${urlArgs(args)}`)
export const useApiFormAnalytic = args => useApiForm(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic${urlArgs(args)}`)

export const useApiListAnalyticTopic = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-topic${urlArgs(args)}`)
export const useApiFormAnalyticTopic = args => useApiForm(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-topic${urlArgs(args)}`)

export const useApiListAnalyticParent = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-parent${urlArgs(args)}`)
export const useApiFormAnalyticParent = args => useApiForm(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-parent${urlArgs(args)}`)

export const useApiListAnalyticType = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-type${urlArgs(args)}`)
export const useApiFormAnalyticType = args => useApiForm(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-type${urlArgs(args)}`)

export const useApiListAnalyticParentType = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-parent-type${urlArgs(args)}`)
export const useApiFormAnalyticParentType = args => useApiForm(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-parent-type${urlArgs(args)}`)

export const useApiListAnalyticPeriod = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/analytic-period${urlArgs(args)}`)


export const useApiListReportGeneralOrg = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-general-org${urlArgs(args)}`)
export const useApiBlobReportGeneralOrg = args => useApiBlob(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-general-org${urlArgs(args)}`)

export const useApiListReportGeneralUser = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-general-user${urlArgs(args)}`)

export const useApiListReportGeneralCourse = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/report-general-course${urlArgs(args)}`)

export const useApiListGraphCustomCourse = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/graph-custom-course${urlArgs(args)}`)

export const useApiListGraphGeneralCourse = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/graph-general-course${urlArgs(args)}`)

export const useApiListGraphGeneralOrg = args => useApiList(process.env.REACT_APP_API_ANALYTICS, `api/v1/graph-general-org${urlArgs(args)}`)

// The organization's LMS connections, archived ones included, for the reports'
// source filter: resolves to { connections: [{ id, name, delivery, archived }] }.
// Rejects on 404 lms_insights.unavailable, where LMS insights don't exist for
// the organization (no LMS schema, or its LMS feature is off), and on 403
// without Analytics read. A direct call, not a list hook: the 404 is the
// ordinary answer for an organization without an LMS, which a hook would log
// as an error, and the filter needs a stable function to call from an effect.
export const getLmsInsightConnections = () =>
  getAsync(process.env.REACT_APP_API_ANALYTICS, 'api/v1/lms-insight/connections').then(result => result.data)

// What the LMS insights filter bar offers (GET lms-insight/details?tz=
// &connection=): the courses mapped on the organization's LMS connections (the
// one connection's, when given), the intervals and the retention cutoffs.
// Rejects as getLmsInsightConnections does.
export const getLmsInsightDetails = query =>
  getAsync(process.env.REACT_APP_API_ANALYTICS, `api/v1/lms-insight/details?${query}`).then(result => result.data)

// One launch report of the LMS insights pages: report is series, summary or
// refusals, query the filters (view/analytics/lms/lms-insight-query.js). A
// direct call for the same reason: a 404 lms_insights.unavailable is an
// answer the page shows, not an error to log.
export const getLmsInsightLaunchReport = (report, query) =>
  getAsync(process.env.REACT_APP_API_ANALYTICS, `api/v1/lms-insight/launches/${report}?${query}`).then(result => result.data)
